<ion-header>
  <ion-header>
    <cc-header [info]="header" (iconClicked)="modalCtrl.dismiss()">
    </cc-header>
  </ion-header>
</ion-header>

<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="getPendings($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>


  <ng-container *ngIf="!httpError">

    <cc-skeletons [type]="skeleton"></cc-skeletons>

    <ion-toolbar class="filter-toolbar" *ngIf="pendings.length && !skeleton.show">
      <ion-segment class="ion-no-padding segment" value="0" (ionChange)="filterByTye($event)">
        <ion-segment-button value="0" checked>
          <ion-label>{{ 'pending-orders-modal.Todas'  | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="1">
          <ion-label>{{ 'pending-orders-modal.Cierre trabajos'  | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-toolbar>


    <div *ngIf="!filteredPendings.length && !skeleton.show" class="outer-container">
      <div class="inner-container">
        <div class="centered-content">
          <span class="no-data">
            <ion-text large class="no-data" color="medium">
              <ion-icon name="file-tray"></ion-icon>
              <br><br>
              {{ 'pending-orders-modal.No hay tareas pendientes'  | translate }} 
            </ion-text>
          </span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="filteredPendings.length && !skeleton.show">
      <ion-grid fixed class="ion-no-padding card-container">
        <ion-row>
          <ion-col class="ion-no-padding" size="12" *ngFor="let p of filteredPendings">
            <cc-pending [pending]="p" [unit]="unitId" [isOnline]="isOnline" [timeResponseConfig]="p.timeResponseConfig" (finishedAction)="ngOnInit()">
            </cc-pending>
          </ion-col>

        </ion-row>
      </ion-grid>
    </ng-container>
  </ng-container>

  <cc-http-error *ngIf="httpError" [errorMsg]="httpError" (retry)="getPendings()"></cc-http-error>

</ion-content>